/** Detect current window width (for usage in global scope) */
const checkWindowWidth = function() {
    const windowWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (windowWidth >= 1200) {
        window.currentScreen = 'desktop';
    }
    else if (windowWidth >= 1024 && windowWidth <= 1199) {
        window.currentScreen = 'tabletLarge';
    }
    else if (windowWidth >= 768 && windowWidth <= 1023) {
        window.currentScreen = 'tabletSmall';
    }
    else {
        window.currentScreen = 'mobile';
    }

    // console.log(window.currentScreen);
};

document.addEventListener('DOMContentLoaded', checkWindowWidth);
window.addEventListener('resize', checkWindowWidth);

/** Header-fixed, header's phones and header's main nav-menu */
document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.b-header');
    const headerTop = document.querySelector('.b-header__top');

    const headerCallInner = document.querySelector('.b-header__call .b-call__inner');
    const headerCallArrow = document.querySelector('.b-header__call .b-call__arrow');
    const headerCallText = document.querySelector('.b-header__call .b-call__text');

    const headerNav = document.querySelector('.b-header__nav');
    const headerNavMenuItems = document.querySelectorAll('.b-header__nav .b-menu__item');
    const headerBtnNavMenu = document.querySelector('.b-header__btn-menu');


    /** Header-fixed */
    if (header && headerTop) {
        let headerTopHeight = headerTop.offsetHeight || 0;
        // console.log(headerTopHeight);

        window.addEventListener('scroll', function () {
            fixHeaderOnScrolling(headerTopHeight);
        });
    }

    function fixHeaderOnScrolling(headerTopHeight) {
        const windowScrollY = window.pageYOffset;
        let customOffsetTop = 400;

        if (windowScrollY >= 200 && windowScrollY < customOffsetTop) {
            header.classList.add('b-header--offtop');
        }
        else if (windowScrollY >= customOffsetTop) {
            header.classList.remove('b-header--offtop');
            header.classList.add('b-header--fixed');
            header.style.paddingTop = headerTopHeight + 'px';
        }
        else {
            header.classList.remove('b-header--offtop');
            header.classList.remove('b-header--fixed');
            header.style.paddingTop = '';
        }
    }



    /** Header's phones */
    if (headerCallText) {
        showHeaderPhoneNumber();
    }

    if (headerCallInner && headerCallArrow) {
        toggleHeaderPhoneSubmenu();
    }

    function showHeaderPhoneNumber() {
        if (window.currentScreen && window.currentScreen !== 'mobile') {
            headerCallText.addEventListener('click', addActiveClass);
            headerCallText.addEventListener('click', hideHeaderPhoneCode);
        }
        else {
            headerCallText.removeEventListener('click', addActiveClass);
            headerCallText.removeEventListener('click', hideHeaderPhoneCode);
        }
    }

    function hideHeaderPhoneCode() {
        this.previousElementSibling.classList.add('js-hidden');
    }

    // Open/close phones-menu
    function toggleHeaderPhoneSubmenu() {
        if (window.currentScreen && window.currentScreen !== 'mobile') {
            headerCallArrow.addEventListener('click', toggleActiveClass);

            document.addEventListener('click', function () {
                const target = event.target;
                //console.log(target);

                if (!target.classList.contains('b-call__arrow')) {
                    headerCallArrow.classList.remove('js-active');
                }
            });
        }
        else {
            headerCallInner.addEventListener('click', toggleActiveClass);

            document.addEventListener('click', function () {
                const target = event.target;
                //console.log(target);

                if (!target.classList.contains('b-call__inner')) {
                    headerCallInner.classList.remove('js-active');
                }
            });
        }
    }



    /** Header's main nav-menu */
    if (headerNavMenuItems.length) {
        toggleHeaderNavMenuSubmenus();
    }

    if (headerBtnNavMenu && headerNav) {
        toggleHeaderNavMenuMobile();
    }

    // Show/hide submenus in main header's navigation-menu
    function toggleHeaderNavMenuSubmenus() {
        [].forEach.call(headerNavMenuItems, function (el) {
            el.addEventListener('click', toggleActiveClass);
            el.addEventListener('mouseleave', removeActiveClass);
        });
    }

    // Show/hide main header's navigation-menu
    function toggleHeaderNavMenuMobile() {
        headerBtnNavMenu.addEventListener('click', toggleActiveClass);

        headerBtnNavMenu.addEventListener('click', function () {
            headerNav.classList.toggle('js-active');
        });

        if (window.currentScreen && window.currentScreen !== 'desktop') {
            document.addEventListener('click', function () {
                const target = event.target;
                //console.log(target);

                if (
                    !target.classList.contains('b-header__btn-menu')
                    && !target.classList.contains('b-header__nav')
                    && !target.classList.contains('b-nav__menu')
                    && !target.classList.contains('b-menu__item')
                    && !target.classList.contains('b-menu__link')
                )
                {
                    headerBtnNavMenu.classList.remove('js-active');

                    headerNav.classList.remove('js-active');
                    headerNav.style.top = '';
                }
            });
        }
    }



    /** Common functions */
    function addActiveClass() {
        this.classList.add('js-active');
    }

    function removeActiveClass() {
        this.classList.remove('js-active');
    }

    function toggleActiveClass() {
        this.classList.toggle('js-active');
    }
});



/** Header's category-menu */
document.addEventListener('DOMContentLoaded', function () {
    const headerCategoryMenu = document.querySelector('.b-header__category');

    if (headerCategoryMenu) {
        toggleHeaderCategoryMenu();
    }

    // Expand/Collapse category-menu
    function toggleHeaderCategoryMenu() {
        const categoryMenuList = document.querySelector('.b-header__category .b-category__items');
        const categoryMenuItem = document.querySelector('.b-header__category .b-category__item');
        const categoryMenuBtn = document.querySelector('.b-header__category .b-category__btn');
        const categoryMenuBtnText = document.querySelector('.b-header__category .b-category__btn-text');
        const categoryMenuSep = document.querySelector('.b-header__category .b-category__separator');

        let menuListFullHeight = categoryMenuList.clientHeight || 0;
        // console.log(menuListFullHeight);

        let menuListMaxHeight;
        let menuItemHeight = categoryMenuItem.clientHeight || 0;
        // console.log(menuItemHeight);

        const menuListObj = {};
        // Set original height to prevent value from override
        menuListObj.origHeight = menuListFullHeight;


        // Check window width
        // Set height of menu based on the number of visible rows / elements
        if (window.currentScreen) {
            switch (window.currentScreen) {
                case 'desktop':
                case 'tabletLarge':
                case 'tabletSmall':
                    menuListMaxHeight = menuItemHeight * 2; // * n - number of visible rows, not real elements!
                    break;

                case 'mobile':
                    menuListMaxHeight = menuItemHeight * 2; // * n - number of real elements!
                    break;

                default:
                    menuListMaxHeight = menuItemHeight * 2; // * n - default number
            }
        }


        if (menuListFullHeight > menuListMaxHeight) {
            collapseMenu();

            // Enable button for Expand/Collapse menu
            categoryMenuBtn.style.display = 'flex';

            categoryMenuBtn.addEventListener('click', function () {
                if (headerCategoryMenu.classList.contains('b-category--expanded')) {
                    collapseMenu();

                    categoryMenuBtnText.textContent = categoryMenuBtnText.dataset.expandText;
                }
                else {
                    expandMenu();

                    categoryMenuBtnText.textContent = categoryMenuBtnText.dataset.collapseText;
                }
            });
        }
        else {
            // Disable button
            categoryMenuBtn.style.display = 'none';

            if (window.currentScreen && window.currentScreen !== 'mobile') {
                if (categoryMenuSep) {
                    // Show separator line
                    categoryMenuSep.style.display = 'block';
                }
                
            }
        }


        function collapseMenu() {
            headerCategoryMenu.classList.remove('b-category--expanded');
            headerCategoryMenu.classList.add('b-category--collapsed');

            // Set max height
            categoryMenuList.style.maxHeight = menuListMaxHeight + 'px';
        }


        function expandMenu() {
            headerCategoryMenu.classList.remove('b-category--collapsed');
            headerCategoryMenu.classList.add('b-category--expanded');

            // Set original height
            categoryMenuList.style.maxHeight = menuListObj.origHeight + 'px';
        }
    }
});



/** Header's short-description */
document.addEventListener('DOMContentLoaded', function () {
    const headerDesc = document.querySelector('.b-header__desc');
    const headerDescText = document.querySelector('.b-header__desc .b-desc__text');

    if (headerDesc && headerDescText) {
        trimHeaderDescText();
    }

    // 1 step - Trim text
    function trimHeaderDescText() {
        let htmlString = headerDescText.innerHTML || '';
        let textString = headerDescText.textContent || '';
        // console.log(htmlString);
        // console.log(textString);

        let stringMaxLength;

        // Trimmed html text
        let htmlStringTrimmed;


        // Remove spaces from the start and the end of strings
        let htmlStringEscaped = htmlString.replace(/^\s+|\s+$/g, '');
        let textStringEscaped = textString.replace(/^\s+|\s+$/g, '');
        // console.log(htmlStringEscaped.length);
        // console.log(textStringEscaped.length);


        // Set max length of text
        if (window.currentScreen) {
            switch (window.currentScreen) {
                case 'desktop':
                    stringMaxLength = 570;
                    break;

                case 'tabletLarge':
                    stringMaxLength = 500;
                    break;

                case 'tabletSmall':
                    stringMaxLength = 350;
                    break;

                case 'mobile':
                    stringMaxLength = 100;
                    break;

                default:
                    stringMaxLength = 570;
            }
        }


        if (textStringEscaped.length > stringMaxLength) {
            // Trim text by length of real text, without html entities
            htmlStringTrimmed = htmlStringEscaped.replace(/\.+$/g, '').substring(0, stringMaxLength - 3) + "... ";

            // Set trimmed text
            headerDescText.innerHTML = htmlStringTrimmed;

            // 2 step
            addButton(htmlStringEscaped);
        }
    }

    // 2 step - Append button to the end of trimmed-text
    function addButton(htmlStringEscaped) {
        let headerDescBtnMore = document.createElement('button');

        headerDescBtnMore.classList.add('b-desc__btn-more');
        headerDescBtnMore.textContent = 'Подробнее';

        headerDescText.appendChild(headerDescBtnMore);

        // 3 step
        headerDescBtnMore.addEventListener('click', function () {
            fadeOut(htmlStringEscaped);
        });
    }

    // 3 step - Trimmed-text fadeOut
    function fadeOut(htmlStringEscaped) {

        headerDescText.style.opacity = 0;

        // 4 step
        headerDescText.addEventListener('transitionend', function() {
            // Second parameter is a callback for "fadeIn" function
            changeText(htmlStringEscaped, fadeIn);
        });
    }

    // 4 step - Replace current text with full-text
    function changeText(htmlStringEscaped, callback) {
        headerDescText.innerHTML = htmlStringEscaped;

        // 5 step
        callback();
    }

    // 5 step - Full-text fadeIn
    function fadeIn() {
        headerDescText.style.opacity = 1;
    }
});



/** Header's tasks */
document.addEventListener('DOMContentLoaded', function () {
    const headerTaskItems = document.querySelectorAll('.b-header__task .b-task__item');

    if (headerTaskItems.length) {
        changeGridOfHeaderTasks();
    }

    function changeGridOfHeaderTasks() {
        if (headerTaskItems.length <= 4) {
            [].forEach.call(headerTaskItems, function (el) {
                el.classList.add('b-task__item--col-2');
            });
        }
    }
});



/** Footer's btn-up and phone */
document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('.b-footer');
    const footerBtnUp = document.querySelector('.b-footer__btn-up');
    const footerCallText = document.querySelector('.b-footer__call .b-call__text');
    const footerCallCode = document.querySelector('.b-footer__call .b-call__code');


    /** Footer's btn-up */
    if (footerBtnUp) {
        window.addEventListener('scroll', fixFooterBtnOnScrolling);
    }

    function fixFooterBtnOnScrolling() {
        const windowHeight = window.innerHeight
            || document.documentElement.clientHeight;

        const documentHeight = document.body.clientHeight
            || document.documentElement.scrollHeight;
        // console.log(documentHeight);

        const windowScrollY = window.pageYOffset;

        let footerHeight = footer.clientHeight || 0;
        // console.log(footerHeight);


        if (
            window.currentScreen
            && window.currentScreen !== 'desktop'
            && windowScrollY > windowHeight
            && windowScrollY + windowHeight <= documentHeight - footerHeight
        )
        {
            footerBtnUp.classList.add('b-footer__btn-up--fixed');
        }
        else {
            footerBtnUp.classList.remove('b-footer__btn-up--fixed');
        }
    }



    /** Footer's phone */
    if (footerCallText && footerCallCode) {
        footerCallText.addEventListener('click', showFooterPhoneNumber);
    }

    function showFooterPhoneNumber() {
        this.classList.add('js-active');

        footerCallCode.classList.add('js-hidden');
    }
});



/**
 * Tooltips with dynamic positioning in javascript
 *
 * @example
 * Add tooltip in html:
 * <span class="g-tooltip-new g-tooltip-new--white" data-tooltip-new='Text for tooltip'></span>
 *
 * Set text only in "data-tooltip-new" attribute
 *
 * Set modificators for icon color (default color is black):
 * --white, --gray, --blue, --mint, --green, --lime-green, --yellow, --red
 */
document.addEventListener('DOMContentLoaded', function() {
    const tooltips = document.getElementsByClassName('g-tooltip-new');

    if (tooltips.length) {
        initTooltips();
    }

    function initTooltips() {
        [].forEach.call(tooltips, function (el) {
            el.addEventListener('mouseenter', addTooltip);
            el.addEventListener('mouseleave', removeTooltip);
        });

        function addTooltip() {
            const target = event.target;
            let tooltipArrow = document.createElement('div');
            let tooltipElem = document.createElement('div');
            let tooltipText = target.getAttribute('data-tooltip-new') || '';

            // Minimal offset for tooltip from left/right side of screen
            let minXOffset = 3;

            const targetCoords = target.getBoundingClientRect();
            // console.log(targetCoords);

            const windowWidth = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;


            // Append arrow to tooltip
            tooltipArrow.className = 'g-tooltip-new-arrow';
            target.appendChild(tooltipArrow);


            // Set text to tooltip and append tooltip to body
            tooltipElem.className = 'g-tooltip-new-text';
            tooltipElem.innerHTML = tooltipText;
            document.body.appendChild(tooltipElem);


            // console.log(targetCoords.left);
            // console.log(windowWidth - targetCoords.right);

            // Positioning tooltip to the left side of the screen
            if (targetCoords.left <= (windowWidth - targetCoords.right)) {
                let leftPos = targetCoords.left + (target.offsetWidth - tooltipElem.offsetWidth) / 2;

                if (leftPos < 0) {
                    leftPos = minXOffset;
                }

                tooltipElem.style.left = leftPos + 'px';
            }
            // Positioning to the right side
            else {
                let rightPos = windowWidth - targetCoords.right + (target.offsetWidth - tooltipElem.offsetWidth) / 2;

                if (rightPos < 0) {
                    rightPos = minXOffset;
                }

                tooltipElem.style.right = rightPos + 'px';
            }

            // Positioning to the top
            let topPos = targetCoords.bottom + tooltipArrow.clientWidth - 5;
            tooltipElem.style.top = topPos + 'px';


            // Prevent tooltip freezes
            window.addEventListener('scroll', removeTooltip);
            window.addEventListener('resize', removeTooltip);
            window.addEventListener('orientationchange', removeTooltip);
        }

        function removeTooltip() {
            window.removeEventListener('scroll', removeTooltip);
            window.removeEventListener('resize', removeTooltip);
            window.removeEventListener('orientationchange', removeTooltip);

            const tooltipElem = document.querySelector('.g-tooltip-new-text');
            const tooltipArrow = document.querySelector('.g-tooltip-new-arrow');

            if (!tooltipElem) { return; }

            // Remove arrow and tooltip from body
            tooltipArrow.remove();
            document.body.removeChild(tooltipElem);
        }
    }
});



/** Lazy loading images
 *
 * Modified methods from developers.google.com
 * Orig: https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video
 *
 * @example
 * Add class "img-lazy" and replace "src" with "data-src" in html:
 * <img class="img-lazy" data-src="path-to-image/img.jpg" alt="" />
 */
document.addEventListener('DOMContentLoaded', function () {
    let lazyImages = [].slice.call(document.querySelectorAll('.img-lazy'));

    if ('IntersectionObserver' in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;

                    lazyImage.src = lazyImage.dataset.src;

                    if (lazyImage.dataset.srcset) {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                    }

                    lazyImage.classList.remove('img-lazy');
                    lazyImage.classList.add('img-loaded');

                    lazyImageObserver.unobserve(lazyImage);

                    // console.log('image loaded by IntersectionObserver');
                }
            });
        });

        lazyImages.forEach(function(el) {
            lazyImageObserver.observe(el);
        });
    }
    else {
        /**  Compatible method for browsers witch not support 'IntersectionObserver' */
        if (lazyImages.length) {
            // console.log(lazyImages);

            let isActive = false;

            const lazyLoad = function () {
                if (isActive === false) {
                    isActive = true;

                    setTimeout(function () {
                        lazyImages.forEach(function (el) {
                            if (
                                (
                                    el.getBoundingClientRect().top <= window.innerHeight
                                    && el.getBoundingClientRect().bottom >= 0
                                )
                                && getComputedStyle(el).display !== 'none'
                            )
                            {
                                el.src = el.dataset.src;

                                if (el.dataset.srcset) {
                                    el.srcset = el.dataset.srcset;
                                }

                                el.classList.remove('img-lazy');
                                el.classList.add('img-loaded');

                                lazyImages = lazyImages.filter(function (image) {
                                    // console.log(lazyImages);
                                    return image !== el;
                                });

                                if (lazyImages.length === 0) {
                                    window.removeEventListener('scroll', lazyLoad);
                                    window.removeEventListener('resize', lazyLoad);
                                    window.removeEventListener('orientationchange', lazyLoad);

                                    // console.log('image loaded by compatible method');
                                }
                            }
                        });

                        isActive = false;

                        // console.log('check lazy loading');
                    }, 200);
                }
            };

            window.addEventListener('scroll', lazyLoad);
            window.addEventListener('resize', lazyLoad);
            window.addEventListener('orientationchange', lazyLoad);

            // Prevent images to be not loaded when they are in viewport
            window.addEventListener('load', lazyLoad);
        }
    }
});



/** Check for IE11 browser */
document.addEventListener('DOMContentLoaded', function () {
    // Check for IE11
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    // True for IE11, false for other IE versions and Edge
    if (isIE11 === true) {
        // Add class for custom styles
        document.documentElement.classList.add('ie11');


        // Polyfill for remove() method
        // Orig: https://developer.mozilla.org/ru/docs/Web/API/ChildNode/remove
        (function() {
            var arr = [window.Element, window.CharacterData, window.DocumentType];
            var args = [];

            arr.forEach(function (item) {
                if (item) {
                    args.push(item.prototype);
                }
            });

            // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
            (function (arr) {
                arr.forEach(function (item) {
                    if (item.hasOwnProperty('remove')) {
                        return;
                    }
                    Object.defineProperty(item, 'remove', {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: function remove() {
                            this.parentNode.removeChild(this);
                        }
                    });
                });
            })(args);
        })();
    }
});